/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayChampionPairDtoSchema = z.object({
  championA: z.string().nullish(),
  championB: z.string().nullish(),
  games: z.optional(z.int()),
  wins: z.optional(z.int()),
  synergyKind: z.string().nullish(),
});
